<template>
  <div class="flex-grow-1 email-to-selector">
    <!-- Select periodo -->
    <v-select
      v-model="selected"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      multiple
      label="id"

      input-id="notification-to"
      :loading="showLoader"
      :disabled="showLoader"
      :placeholder="showLoader ? 'Cargando periodos ...' : 'Seleccione un periodo'"
      :options="periodos"
      :selectable="() => selected.length < 1"
      :reduce="val => val.id"
      @input="(val) => $emit('add-id-referencia-lk', val[0])"
    >
      <!-- Options -->
      <template #option="{ clave, temp_nombre, fecha_ini, fecha_fin }">
        <div
          v-b-tooltip.hover="`${timestampToDate(fecha_ini)} - ${timestampToDate(fecha_fin)}`"
          class="text-truncate"
        >
          <span><b>{{ clave }}</b> {{ temp_nombre }}</span>
        </div>
      </template>

      <!-- Selected option -->
      <template #selected-option="{ clave, temp_nombre, fecha_ini, fecha_fin }">
        <span
          v-b-tooltip.hover="`${timestampToDate(fecha_ini)} - ${timestampToDate(fecha_fin)}`"
          class="text-white"
        >
          <b>{{ clave }}</b> {{ temp_nombre }}
        </span>
      </template>

      <!-- No options -->
      <template #no-options>
        No encontramos resultados
      </template>

      <!-- Loader -->
      <template #spinner="{ loading }">
        <b-spinner
          v-if="loading"
          small
          variant="primary"
        />
      </template>
    </v-select>

    <!-- Select plan -->
    <v-select
      v-if="selected.length"
      v-model="selectedPlan"
      v-b-tooltip.hover="`Si desea notificar a un plan de estudios en particular del periodo seleccionado (${selected[0]}), búsquelo aquí`"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      multiple
      label="nombre"
      class="flex-grow-1 email-to-selector"
      input-id="notification-to"
      :loading="showLoader"
      :disabled="showLoader || !selected.length"
      :placeholder="showLoader ? 'Cargando planes de estudio ...' : 'Seleccione un plan de estudio (opcional)'"
      :options="planes"
      :selectable="() => selectedPlan.length < 1"
      :reduce="val => val.id"
      @input="(val) => $emit('add-id-plan', val[0])"
    >
      <!-- Options -->
      <template #option="{ nombre }">
        <div class="text-truncate">
          <span>{{ nombre }}</span>
        </div>
      </template>

      <!-- Selected option -->
      <template #selected-option="{ nombre }">
        <span class="text-white">{{ nombre }}</span>
      </template>

      <!-- No options -->
      <template #no-options>
        No encontramos resultados
      </template>

      <!-- Loader -->
      <template #spinner="{ loading }">
        <b-spinner
          v-if="loading"
          small
          variant="primary"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
import {
  VBTooltip,
  BSpinner,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import { timestampToDate } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    vSelect,
    BSpinner,
  },
  setup() {
    const toast = useToast()
    const showLoader = ref(false)
    const selected = ref([])
    const selectedPlan = ref([])
    const periodos = ref([])
    const planes = ref([])

    // * Load periodos
    const loadData = () => {
      showLoader.value = true
      const paramsRequest = {
        action: 1,
        token: store.state.cuenta.session.token,
      }
      getData(paramsRequest, 'wsperiodo')
        .then(response => {
          showLoader.value = false
          if (response.status === 200) {
            periodos.value = response.data.data || []
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error cargando periodos',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          showLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando periodos',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    // * Load planes
    const loadDataPlanes = () => {
      showLoader.value = true
      getData({ action: 15 }, 'wspublico')
        .then(response => {
          showLoader.value = false
          if (response.status === 200) {
            planes.value = response.data.planes || []
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error cargando planes de estudio',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          showLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando planes de estudio',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    onMounted(() => { loadData(); loadDataPlanes() })

    // * Asign default data
    const resetComponent = () => { selected.value = []; selectedPlan.value = [] }

    return {
      showLoader,
      periodos,
      planes,
      selected,
      selectedPlan,
      timestampToDate,
      resetComponent,
    }
  },
}
</script>
